/**
 * Lightweight cookie-consent store backed by localStorage.
 * Shape:
 *   { marketing: boolean, savedAt: ISO string, version: 1 }
 * No 3rd-party CMP required. Other modules subscribe to consent changes via
 * the 'drivehr:consent-changed' window event.
 */
const STORAGE_KEY = 'drivehr_cookie_consent_v1';
export const CONSENT_EVENT = 'drivehr:consent-changed';
export const OPEN_PREFERENCES_EVENT = 'drivehr:open-cookie-preferences';

export const getConsent = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (typeof parsed?.marketing !== 'boolean') return null;
    return parsed;
  } catch {
    return null;
  }
};

export const setConsent = ({ marketing }) => {
  const payload = { marketing: !!marketing, savedAt: new Date().toISOString(), version: 1 };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: payload }));
  return payload;
};

export const clearConsent = () => {
  localStorage.removeItem(STORAGE_KEY);
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: null }));
};

export const openPreferences = () => {
  window.dispatchEvent(new Event(OPEN_PREFERENCES_EVENT));
};
